<template>
  <v-list two-line>
    <v-list-tile v-if="`${prefix}_power` in network">
      <v-list-tile-action>
        <v-progress-circular v-if="loading" indeterminate :color="power ? 'blue' : 'grey'"></v-progress-circular>
        <v-switch v-else v-model="power" color="blue"></v-switch>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title v-if="loading">{{power? $t('network-wlan0-power-state-on-ing') : $t('network-wlan0-power-state-off-ing')}}</v-list-tile-title>
        <v-list-tile-title v-else-if="power">{{$t('network-wlan0-power-state-on')}}</v-list-tile-title>
        <v-list-tile-title v-else>{{$t('network-wlan0-power-state-off')}}</v-list-tile-title>
        <v-list-tile-sub-title>{{$t('network-wlan0-power-state')}}</v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile v-if="`${prefix}_internet_access` in network">
      <v-list-tile-action>
        <v-icon :color="network[prefix + '_internet_access'] ? 'green' : 'red'">language</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>{{network[`${prefix}_internet_access`]}}</v-list-tile-title>
        <v-list-tile-sub-title>{{$t('current-network-state')}}</v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
    <span v-if="power">
      <v-list-tile v-if="`${prefix}_internet_access` in network">
        <v-list-tile-action>
          <v-icon :color="network[prefix + '_internet_access'] ? 'green' : 'red'">language</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{network[`${prefix}_internet_access`]}}</v-list-tile-title>
          <v-list-tile-sub-title>{{$t('current-network-state')}}</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-action>
          <loading-icon :color="power ? 'blue' : 'grey'" :loading="loading" icon="timeline"></loading-icon>
          
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{network[prefix + '_current_address']}}</v-list-tile-title>
          <v-list-tile-sub-title>{{$t(`network-${prefix}-current-address`)}}</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-action>
          <v-icon>repeat</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{network[prefix + '_current_macaddress']}}</v-list-tile-title>
          <v-list-tile-sub-title>{{$t(`network-${prefix}-current-macaddress`)}}</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </span>
  </v-list>
</template>

<script>
import { mapState } from "vuex";
import { mapGetters } from "vuex";
import LoadingIcon from "./LoadingIcon";
export default {
  name: "NetworkSettingStatus",
  components: {
    LoadingIcon
  },
  props: {
    prefix: String
  },
  data: () => {
    return {
    };
  },
  computed: {
    ...mapGetters(["network", "loading"]),
    power: {
      get: function() {
        if (`${this.prefix}_power` in this.network) {
          return this.network[`${this.prefix}_power`] == 'on';
        }
        return true; //caso della lan
      },
      set: function(newValue) {
        if (newValue) {
          console.log("Going to turn on wlan");
          
        }else {
          console.log("Going to turn off wlan");
        }
        this.network[`${this.prefix}_power`] = newValue ? "on" : "off";
        this.$store.dispatch("saveNetwork");
      }
    }
  },
  methods: {}
};
</script>